/**
 * The golf/MMA launch state -- SCORES-3/Q61: both ship flatly `Coming soon`
 * at launch, never a partial leaderboard or bout card, and never the
 * two-team header layout. The Scores league drill-down reuses it with its own
 * fan-facing body line (ISSUE-1020), so golf and MMA share the same Coming
 * soon headline and layout on both screens.
 */
import type { ReactNode } from "react";

export const GAME_DETAIL_COMING_SOON_BODY =
  "This sport's game detail isn't ready yet. Check back after launch.";

export type typeComingSoonProps = {
  /** The second line. Defaults to the game detail line. */
  body?: string | undefined;
  /** The root element's data-testid. Defaults to "game-detail-coming-soon". */
  testId?: string | undefined;
};

export const ComingSoon = (props: typeComingSoonProps): ReactNode => (
  <div
    className="mx-auto flex max-w-120 flex-col items-center gap-2 py-10 text-center"
    data-testid={props.testId ?? "game-detail-coming-soon"}
  >
    <p className="text-body-strong text-ink">Coming soon</p>
    <p className="text-body text-ink-secondary">
      {props.body ?? GAME_DETAIL_COMING_SOON_BODY}
    </p>
  </div>
);
